module.exports = __webpack_public_path__ + "img/img_0.5b8b2297.png";